import policyMedicinesCheckList from "./master-medicines-check-list/MasterMedicinesCheckList.vue";
import i18n from "../../i18n/index";
import locationService from "../../services/location/LocationService.js";
import vademecumService from "../../services/masterMedicine/master-medicine.js";
import providerService from '../../services/provider/ProviderService';


export default {
    components: {
        policyMedicinesCheckList,
    },
    data: () => ({
        hideList: false,
        editProccess: false,
        mun: {
            // ActiveIngredient: "",
             description: "",
            // nameTrade: "",
            plu: "",
            // quantity: 0,
            isApplicable: false,
            isWatched: false,
            // active: true,
            // provider: 0,
        },
        update: 0,
        rules: [
            (value) => !!value || i18n.t("field-required"),
            (v) => !v || v.length <= 200 || "Máximo 200 dígitos",
        ],

        numberRules: [
            (value) => !!value || i18n.t("field-required"),
            (v) => !v || v.length <= 10 || "Máximo 10 dígitos",
            (v) => !v || /^\d+$/.test(v) || "Solo números",
            // incluye aquí cualquier otra regla que necesites...
        ],
        validForm: true,
        loadingSaveButton: false,
        states: [],
        cities: [],
        loadingDelete: false,
        showDelete: false,
        providers: [],
    }),
    created() {
        // this.getStates();
        // this.getProviders();
    },
    methods: {
        handleMunicipio(item) {
            this.hideList = true;
            this.showIcon = false;
            this.mun.id = item.id;
            this.mun.plu = item.plu;
            // this.mun.ActiveIngredient = item.ActiveIngredient;
             this.mun.description = item.description;
            // this.mun.nameTrade = item.nameTrade;
            // this.mun.quantity = item.quantity;
            this.mun.isApplicable = item.isApplicable;
            this.mun.isWatched = item.isWatched;
            // this.mun.active = item.active;
            // this.mun.provider = item.provider;
            this.editProccess = true;
            this.update = 1;
            this.loadingDelete = false;
            this.showDelete = true;
        },
        closeUser() {
            this.hideList = false;
            this.dialog = false;
            this.mun = {
                // ActiveIngredient: "",
                description: "",
                // nameTrade: "",
                plu: "",
                // quantity: 0,
                isApplicable: false,
                isWatched: true,
                // active: true,
            };
            this.showIcon = false;
            this.$refs.municipioform.reset();
            this.editProccess = false;
            this.update = 0;
            this.showDelete = false;
        },
        async getStates() {
            await locationService.getStatesByCountry().then((response) => {
                this.states = response.data;
            });
        },
        save() {
            if (!this.$refs.municipioform.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields"),
                });
                return;
            }
            // this.mun.id = this.mun.id == '' ? this.$refs.munipicioList.getLenght() + 1 : this.mun.id;
            this.editProccess = false;
            vademecumService
                .createVademecun(this.mun)
                .then((result) => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-successfully-created"),
                        });
                    }
                    this.$refs.municipioList.searchCity();
                    this.closeUser();
                })
                .catch((err) => {
                    throw err;
                });
        },
        updateMunicipio() {
            let VademecunId = this.mun.id;
            let data = {
                // name: this.mun.name,
                plu: this.mun.plu,
                // ActiveIngredient: this.mun.ActiveIngredient,
                description: this.mun.description,
                // nameTrade: this.mun.nameTrade,
                // quantity: this.mun.quantity,
                isApplicable: this.mun.isApplicable,
                isWatched: this.mun.isWatched,
                // active: this.mun.active,
            };
            vademecumService
                .updateVademecun(VademecunId, data)
                .then((result) => {
                    if (result.status == 200) {
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: i18n.t("record-update"),
                        });
                        this.$refs.municipioList.searchCity();
                        this.closeUser();
                    }
                })
                .catch((err) => {
                    throw err;
                });
        },
        deleteMunicipio() {
            let VademecunId = this.mun.id;
            this.loadingDelete = true;
            vademecumService
                .deleteVademecun(VademecunId)
                .then((result) => {
                    if (result.status == 200) {
                        this.loadingDelete = false;
                        this.$notify({
                            group: "app",
                            type: "success",
                            text: "Municipio Eliminado",
                        });
                        this.$refs.municipioList.searchCity();
                        this.closeUser();
                    }
                })
                .catch((error) => {
                    this.loadingDelete = false;
                    this.showIcon = false;
                    if (error && error.code) {
                        if (error.code == "The city has associated transactions") {
                            this.$notify({
                                group: "app",
                                type: "error",
                                text: "El municipio tiene transacciones no se puede eliminar",
                            });
                        }
                    }
                    // this.$refs.municipioList.searchCity();
                    // this.closeUser();
                });
        },
        async getProviders() {
            return await providerService.getProviders().then(response => {
                this.providers = response.data;
            });
        },
    },
};